import { createFileRoute } from '@tanstack/react-router';

import Roles from '@/modules/settings/pages/Roles';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/roles/',
)({
  head: () => ({
    meta: [{ title: 'Funções' }],
  }),
  component: Roles,
});
